import { isNotEmptyArray } from '@rumblefish/ui/Rumblefish23Theme';
import type { FC } from 'react';
import { JobPostSection, JobPostList } from '..';
import type { ResponsibilitiesProps } from './Responsibilities.types';

export const Responsibilities: FC<ResponsibilitiesProps> = ({
  responsibilities,
}) => {
  if (!isNotEmptyArray(responsibilities)) {
    return null;
  }
  return (
    <JobPostSection banner="Responsibilities" title="What you'll do?">
      <JobPostList items={responsibilities} />
    </JobPostSection>
  );
};
